import globalStore from "@/store/global"
import PrivateConfirm from "@/components/model-management/components/privateConfirm";
import BaseModal from "..";

const ModelManagementPrivateConfirm = {
  show(data) {
    this.self = BaseModal.show({
      borderRadius: 24,
      content: (
        <PrivateConfirm
          {...data}
          onClose={this.close}
        />
      ),
      wrapClassName: 'nw-base-modal model-confirm-form',
      afterClose: () => {
        globalStore.delModal(this.id);
        this.id = null;
        data?.afterClose?.();
      },
    });
  },
  close() {
    globalStore.delModal(this.id)
    this.id = null;
    if (this.self) {
      this.self.destroy();
      this.self = null
    }
  }
}

export default ModelManagementPrivateConfirm